import React from 'react';
import logo from '../../img/logo.png'

const Logo = () => (
    <div className="logo-container">
        <span><img className="logo" src={logo} alt="LiveSession logo"/><span style={{marginLeft:10}}>Partners</span></span>
    </div>
)

export default Logo;